import "./TopperWithoutReg.css";

import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { SlickArrow } from "~/icons";

import { Text } from "./Text";

export type MultipleData<T> = {
  data: Array<{
    id: number;
    attributes: T;
  }>;
};

export type TextAttributes = {
  component: string;
  pageSlug: string;
  ident: string;
  text: string;
  textAsHtml: boolean;
  mobileText: string;
  mobileTextAsHtml: boolean;
  locale: string;
  localizations: MultipleData<TextAttributes>;
  promo_modifications: MultipleData<{ slug: string }>;
};

export type TextEntry = {
  id: number;
  attributes: TextAttributes;
};

export type TextEntriesCollection<E extends object> = {
  [ident in keyof E]: Array<TextEntry>;
};

export type BannerAttributes = {
  createdAt?: string;
  updatedAt?: string;
  locale?: string;
  href?: string | null;
  ident?: string;
  slug?: string;
  imageVariants?: string;
  mobileImageVariants?: string | null;
  alternativeText?: string;
};

export type emptyTopperTexts = {
  topperTitle: null;
};

type TopperTextCollection = TextEntriesCollection<emptyTopperTexts>;

export type TopperProps = {
  topperTextCollection?: {
    [key: string]: Array<TextEntry>;
  } & TopperTextCollection;
  topperImage?: BannerAttributes | undefined;
  topperBackground?: BannerAttributes | undefined;
  topperTitle?: string;
  topperTitleMobile?: string;
  description?: Array<string>;
  topperIconUrl?: string;
  isMainTopper?: boolean;
  isSlick?: boolean;
  disableTitle?: boolean;
  playNowLink: string;
  playerId?: string;
  slickIndex?: number;
  slickLength?: number;
  handleNext?: () => void;
  handlePrev?: () => void;
  analytics: {
    logInMain: () => void;
    createAccountMain: () => void;
  };
};

/**
 * @deprecated
 */
export const TopperWithoutReg: FC<TopperProps> = (props) => {
  const { t } = useTranslation("mainBanner");
  const { createAccountMain, logInMain } = props.analytics;
  const topperBackground = props?.topperBackground?.imageVariants;
  const topperBackgroundMobile = props?.topperBackground?.mobileImageVariants;

  return (
    <section
      className={`topper-without-reg topper-without-reg_${props.slickIndex}`}
    >
      {props.isMainTopper ? (
        <style>{`
        section.topper-without-reg  {
     
          background-repeat: no-repeat;
          background-position: top center;
          max-width: 2700px;
          margin-left: auto;
          margin-right: auto;
          width: 100%;
        }
        section.topper-without-reg_${props.slickIndex} {
         background-image: url(${topperBackground});
        }
                  
        @media screen and (max-width: 1240px) {
          section.topper-without-reg {
            background-size: 2000px auto;
            background-position:top;         
          }
            
          section.topper-without-reg_${props.slickIndex} {
         background-image: url(${topperBackgroundMobile});
         background-image: url(${topperBackground});
        }
        }
         @media screen and (max-width: 800px){
     section.topper-without-reg {
        background-size: cover;
      }
        section.topper-without-reg_${props.slickIndex} {
         background-image: url(${topperBackgroundMobile});
        }
    }
               
        @media screen and (max-width:450px){
         section.topper-without-reg {
            // background-size: 1250px auto;
              background-size: cover;
          }
        }
      `}</style>
      ) : (
        <style>{`
    section.topper-without-reg {
    
      background-repeat: no-repeat;
      background-position: top center;
      max-width: 2700px;
      margin-left: auto;
      margin-right: auto;
      width: 100%;
    }
      section.topper-without-reg_${props.slickIndex} {
         background-image: url(${topperBackground});
        }
              
    @media screen and (max-width: 1240px) {
      section.topper-without-reg {
        background-size: 1940px auto;
        background-position: center;
      }
    }
    
    @media screen and (max-width: 800px){
     section.topper-without-reg {
        background-size: cover;
      }
        section.topper-without-reg_${props.slickIndex} {
         background-image: url(${topperBackgroundMobile});
        }
    }
    
    @media screen and (max-width:450px){
     section.topper-without-reg {
        background-size: cover;
      
      }
         section.topper-without-reg_${props.slickIndex} {
         background-image: url(${topperBackgroundMobile});
        }
    }
  `}</style>
      )}
      <div
        className={`section-content topper-content ${props?.isMainTopper && "main-topper"}`}
      >
        <div className="title-and-banner-wrapper">
          {props.isSlick && (
            <div>
              <div className="topper-without-reg-counter">
                <div>
                  <span className="topper-without-reg-index">
                    {props.isSlick && `0${props.slickIndex}`}
                  </span>
                  <span className="topper-without-reg-length">
                    {props.isSlick && `/0${props.slickLength}`}
                  </span>
                </div>
                <div className="topper-without-reg-button-container">
                  <button
                    className="topper-without-reg-button"
                    onClick={props.handlePrev}
                  >
                    <SlickArrow />
                  </button>
                  <button
                    className="topper-without-reg-button rotate"
                    onClick={props.handleNext}
                  >
                    <SlickArrow />
                  </button>
                </div>
              </div>
            </div>
          )}
          {!props.disableTitle && (
            <div
              className={`topper-title ${props?.isMainTopper ? "topper-info" : ""}`}
            >
              {props?.topperIconUrl && (
                <img
                  className="topper-info-img"
                  src={props.topperIconUrl}
                  alt=""
                />
              )}
              <div className="topper-title-desktop">
                <Text
                  textCollection={props.topperTextCollection}
                  textEntryIdent="topperTitle"
                  textWithHtml={true}
                  oldText={props.topperTitle}
                />
              </div>
              <div className="topper-title topper-title-mobile">
                <Text
                  textCollection={props.topperTextCollection}
                  textEntryIdent="topperTitle"
                  textWithHtml={true}
                  oldText={props.topperTitle}
                />
              </div>
            </div>
          )}
        </div>
        {props.isSlick && (
          <div>
            <div className="topper-without-reg-button-container-mobile">
              <button
                className="topper-without-reg-button-mobile-left"
                onClick={props.handlePrev}
              >
                <SlickArrow />
              </button>
              <button
                className="topper-without-reg-button-mobile-right rotate"
                onClick={props.handleNext}
              >
                <SlickArrow />
              </button>
            </div>
          </div>
        )}
        <div>
          <div className="topper-buttons">
            <a
              href={props.playNowLink}
              className="button cta-button signup"
              onClick={createAccountMain}
            >
              {t("topper.button.create")}
            </a>
            <a
              href={props.playNowLink}
              className="cta-button login"
              onClick={logInMain}
            >
              {t("topper.button.login")}
            </a>
          </div>
        </div>
        <div />
      </div>
    </section>
  );
};
